import React, {Component} from 'react'
import PropTypes from 'prop-types'

class PrinterDisplay extends Component {
    handleClick = () => {
        const { printer, onChange } = this.props
        onChange('printer', printer)
    }

    render() {
        const { printer } = this.props
        return (
            <td className='PrinterDisplay'>
                <span className='cursor-pointer' onClick={this.handleClick}>{printer || '-'}</span>
            </td>
        )
    }
}

PrinterDisplay.propTypes = {
    printer: PropTypes.string,
    onChange: PropTypes.func.isRequired,
}

export default PrinterDisplay
